import React, { useMemo } from 'react';
import StatisticsGlassCard from './StatisticsGlassCard';
import StatisticsDesktopSectionHeader from './StatisticsDesktopSectionHeader';
import { STATS_ICONS } from './statisticsAssets';
import { Heart, MessageCircle, MoreHorizontal } from 'lucide-react';

export default function StatisticsDesktopRecentVisitsCard({
    visitLogs = [],
    students = [],
}) {
    // 최근 5개의 심방 내역만 추출
    const recentVisits = useMemo(() => {
        return [...visitLogs]
            .filter(log => !!log.date)
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .slice(0, 5)
            .map(log => {
                const student = students.find(s => s.id === log.studentId);
                return {
                    ...log,
                    studentName: student ? student.name : '알 수 없음',
                    studentDepartment: student ? (student.department || student.grade) : '',
                };
            });
    }, [visitLogs, students]);

    return (
        <StatisticsGlassCard className="h-full p-6 flex flex-col">
            <StatisticsDesktopSectionHeader
                iconSrc={STATS_ICONS.memo}
                title="최근 심방 내역"
                badge="RECENT"
            />

            <div className="flex-1 overflow-y-auto mt-2 space-y-3 pr-1 hide-scrollbar">
                {recentVisits.length > 0 ? (
                    recentVisits.map((visit, idx) => (
                        <div key={idx} className="group p-3 rounded-2xl bg-gray-50/50 border border-gray-100/50 hover:bg-white hover:border-gray-200 hover:shadow-sm transition-all duration-300">
                            <div className="flex items-start justify-between mb-1.5">
                                <div className="flex items-center gap-2">
                                    <span className="text-[14px] font-black text-gray-800">{visit.studentName}</span>
                                    <span className="text-[10px] font-bold text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded-md">
                                        {visit.studentDepartment}
                                    </span>
                                </div>
                                <span className="text-[10px] font-bold text-gray-400">{visit.date}</span>
                            </div>

                            <div className="flex flex-col gap-1.5">
                                <p className="text-[12px] font-medium text-gray-600 line-clamp-2 leading-relaxed">
                                    {visit.content || "기록된 내용이 없습니다."}
                                </p>

                                <div className="flex items-center gap-3 pt-1">
                                    <div className="flex items-center gap-1">
                                        <Heart size={10} className="text-rose-400" />
                                        <span className="text-[10px] font-bold text-gray-400">{visit.type || '일반'}</span>
                                    </div>
                                    <div className="flex items-center gap-1">
                                        <MessageCircle size={10} className="text-blue-400" />
                                        <span className="text-[10px] font-bold text-gray-400">{visit.writerName || '익명'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="h-full flex flex-col items-center justify-center opacity-40 py-10">
                        <MoreHorizontal size={32} className="text-gray-300 mb-2" />
                        <p className="text-[13px] font-bold text-gray-400">심방 기록이 없습니다</p>
                    </div>
                )}
            </div>
        </StatisticsGlassCard>
    );
}
